import script from "./channelEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./channelEdit.vue?vue&type=script&lang=ts&setup=true"

import "./channelEdit.vue?vue&type=style&index=0&id=2cd5f8c4&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cd5f8c4"]])

export default __exports__